<div class="map-tile" [style.height]="height">
  <!-- The map is created once and kept; the status overlay sits on top of it, so the saved
       view is applied to the map as soon as the readings arrive. -->
  <kig-map-favorite *ngIf="mapFavorite"
      [sensors]="sensors"
      [sensorReadings]="readings"
      [savedMapDetails]="savedMapDetails"
      [mapFavoriteId]="mapFavorite.id"
      [labelsEditable]="false"
      [minimal]="true"
      [height]="'100%'">
  </kig-map-favorite>

  <div class="map-tile-status" *ngIf="loading">
    <i class="fa fa-spinner fa-spin fa-fw"></i> Loading map ...
  </div>
  <div class="map-tile-status" *ngIf="failed">Unable to load this map's readings.</div>
  <div class="map-tile-status" *ngIf="noReadings">No readings found for the selected date range.</div>
</div>
